import React from 'react';
import { Stack, StackProps, Typography } from '@mui/material';
import InputCurrency from '@/components/Base/InputCurrency.tsx';
import { Tooltip, Fade, IconButton } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface PropsType extends StackProps {
  title: string;
  value?: string;
  percentage?: string | number;
  sign?: boolean;
  formik?: any;
  field?: string;
  status?: 'down' | 'up';
  bgColor?: string | null;
  maxWidth?: string | null;
  tooltipText?: React.ReactNode;
};

const KpiComponent: React.FC<PropsType> = ({ title, value, percentage, sign, formik, field, status, bgColor, tooltipText, ...rest }) => {
  const colorStatus = {
    up: { background: 'rgba(35, 193, 10, 0.15)', color: 'rgba(11, 138, 0, 1)' },
    down: { background: '#DF4A4C', color: '#FFF' },
  };

  return (
    <Stack
      position={'relative'}
      minHeight={'111px'}
      p={'10px'}
      borderRadius={'6px'}
      sx={{ border: '2px solid rgba(236, 238, 246, 1)', width: '100%' }}
      maxWidth={'165.5px'}
      display={'flex'}
      justifyContent={'space-between'}
      bgcolor={bgColor}
      {...rest}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 4, maxWidth: rest?.maxWidth || '120px', marginBottom: 8 }}>
        <Typography color={'#000'} fontSize={'13px'} fontWeight={600}>
          {title}
        </Typography>

        {tooltipText && (
          <Tooltip
            title={
              <div style={{ fontSize: 12 }}>
                {tooltipText}
              </div>
            }
            placement="top"
            arrow
            TransitionComponent={Fade}
            TransitionProps={{ timeout: 300 }}
          >
            <IconButton size="small" sx={{ p: 0, ml: '2px', position: 'absolute', right: '6px', top: '5px' }}>
              <HelpOutlineIcon sx={{ fontSize: 16, color: '#999' }} />
            </IconButton>
          </Tooltip>
        )}
      </div>
      {value && (
        <Typography color={'#000'} fontSize={'20px'} fontWeight={700}>
          {value}
        </Typography>
      )}

      {formik && (
        <InputCurrency
          id={field}
          name={field}
          required
          value={formik.values[field]}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched[field] && !!formik.errors[field]}
          helperText={formik.touched[field] && formik.errors[field] && formik.errors[field]}
          sx={{
            '.MuiInputBase-input': {
              borderRadius: '8px',
              fontWeight: 'bold',
            },
          }}
        />
      )}
    </Stack>
  );
};

export default KpiComponent;
